import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaDescriptorProps } from "@features/seo/utils/types";
import { type Route } from "@route-types/BreakingNews/+types/BreakingNewsPage";
import { fetchBreakingNewsPageData } from "@routes/BreakingNews/BreakingNewsPage.server";
import BreakingNewsPageContent from "@routes/BreakingNews/BreakingNewsPageContent";
import { BreakingNewsPageContext } from "@routes/BreakingNews/utils/types";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { createMetaTags } from "@sphtech/web2-seo-schema";
import { HttpStatusCode } from "axios";

/** The main component for the /breaking-news route. */
const BreakingNewsPage = (): React.ReactElement => {
  const context = useLoaderData<BreakingNewsPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <BreakingNewsPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default BreakingNewsPage;

export const loader = async () => await fetchBreakingNewsPageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaDescriptorProps[] => {
  const context = loaderData as BreakingNewsPageContext;
  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return createMetaTags(data.metaTags);
};
